<script>
  import { onDestroy } from 'svelte'
  import { getId, addElement, getLayoutComponent } from './builder.js'

  export let config = {}

  export let name = null
  export let value = null
  export let id = getId()

  export let format = null
  export let validate = null

  export let label = name || ''
  export let info = null
  export let required = null
  export let disabled = null

  const elementName = 'RadioGroup'
  const element = addElement(v => {
    value = v
  })
  $: element.init({ value, format, validate, name, label, info, required, disabled })

  export const validateValue = element.validateValue

  onDestroy(element.selfDestroy)
</script>

<svelte:component this={getLayoutComponent(elementName)} let:inputClass {config} {elementName} {id}>
  <slot />
</svelte:component>
